import { useQuery } from '@apollo/client';
import { Breadcrumb } from '@aleph/shared-components';
import { SpotifyLevel } from 'wb-spotify/app/routes/superGrid/utils';
import {
	BreadcrumbsDocument,
} from 'wb-spotify/graphql/generated';

interface IUseBreadcrumb {
	params: Record<string, any>;
}

export const useBreadcrumbs = ({
	params,
}: IUseBreadcrumb) => {
	const { data: breadcrumbsData, loading } = useQuery(BreadcrumbsDocument, {
		variables: {
			adAccountFilters:  params.filters,
			campaignFilters:   params.filters,
			groupFilters:      params.filters,
			includeAdAccounts: params.level === SpotifyLevel.CAMPAIGN,
			includeCampaigns:  params.level === SpotifyLevel.GROUP,
			includeGroups:     params.level === SpotifyLevel.AD,
		},
	});

	const adAccount = breadcrumbsData?.adAccountBreadcrumbs?.items?.[0]
	?? breadcrumbsData?.campaignBreadcrumbs?.items?.[0]?.adAccount
	?? breadcrumbsData?.groupBreadcrumbs?.items?.[0]?.campaign?.adAccount;

	const campaign = breadcrumbsData?.campaignBreadcrumbs?.items?.[0]
        ?? breadcrumbsData?.groupBreadcrumbs?.items?.[0]?.campaign;

	const group = breadcrumbsData?.groupBreadcrumbs?.items?.[0];

	const hasMultiple = (breadcrumbsData?.adAccountBreadcrumbs?.items?.length ?? 0) > 1
        || (breadcrumbsData?.campaignBreadcrumbs?.items?.length ?? 0) > 1
        || (breadcrumbsData?.groupBreadcrumbs?.items?.length ?? 0) > 1;

	const breadcrumbs: Breadcrumb[] = [
		...(adAccount ? [{
			id:    adAccount.client.id,
			name:  adAccount?.name,
			level: SpotifyLevel.AD_ACCOUNT,
		}] : []),
		...(campaign ? [{
			id:    campaign.id,
			name:  campaign.name ?? '',
			level: SpotifyLevel.CAMPAIGN,
		}] : []),
		...(group ? [{
			id:    group.id,
			name:  group.name,
			level: SpotifyLevel.GROUP,
		}] : []),
	];

	return { loading, hasMultiple, breadcrumbs };
};
